"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormStatuses = void 0;
var FormStatuses;
(function (FormStatuses) {
    FormStatuses["Init"] = "init";
    FormStatuses["Ready"] = "ready";
})(FormStatuses || (exports.FormStatuses = FormStatuses = {}));
